import { Injectable } from '@angular/core';
import { NotifyService } from '@app/services/notify.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Injectable()
export class ErrorDialogService {
  isDialogOpen = false;
  constructor(private notificationService: NzNotificationService, private notifyService: NotifyService) { }

  openDialog(data): any {
    console.log('Error Data', data);
    if (data.request.url.indexOf('/api/notify/counts') !== -1 || data.request.url.indexOf('/GetFieldValueQueue') !== -1) {
      return;
    } else {
      if (this.isDialogOpen === false) {
        this.isDialogOpen = true;
        let message = '';
        const responseKeys = Object.keys(data);
        if (responseKeys.includes('success')) {
          message = data.message;
        }
        else {
          if (data.error.message === undefined) {
            message = 'Failed to connect';
          }
          else {
            message = data.error.message.substr(0, 200);
          }
          console.log('message', message);
        }

        const dialogRef = this.notificationService.create(
          'error',
          `<b>Backend system error</b>`,
          `${message} ...`,
          { nzPlacement: 'bottomRight' }
        );

        dialogRef.onClose.subscribe(() => {
          this.isDialogOpen = false;
        });

        //this.notifyService.callCount();
      }
    }
  }
}
